export default __webpack_public_path__ + "static/wwc-image3-14ebaaff23d59a1b648c752252f6a683.jpg";